// extracted by mini-css-extract-plugin
module.exports = {"userNavBar":"UserMenu_userNavBar__xOOPy","faUser":"UserMenu_faUser__3Xe2_","active":"UserMenu_active__31mTR","fas":"UserMenu_fas__1LaUO"};